import script from "./tagSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./tagSelector.vue?vue&type=script&setup=true&lang=js"

import "./tagSelector.vue?vue&type=style&index=0&id=3f14e7f6&lang=scss"

const __exports__ = script;

export default __exports__